/** @module Apparel/SupplierItemMixIn */
define ([
    "dojo/_base/declare", 
    "csi/reflection",
    "csi/xml",
    "csi/xml/Query"
], function(declare,reflection,xml,Query) {
    return declare(null,{
        /**
         * Gets a base query with filter for SupplierItem based queries
         * @return {Query} - new Query object with base filter for Active SupplierItems that are valid for selection
         */
        _getSupplierItemStoreBaseQueryFilter: function() {
            const {PATH_CURRENT_REVISION} = reflection;
            var q = new Query().Attr("Active", xml.OP_EQUALS, true, reflection.PATH_PARENT);
            q.Or().Attr(reflection.ATTR_STATE, xml.OP_EQUALS, reflection.REVISION_DRAFT, PATH_CURRENT_REVISION)
                .Attr(reflection.ATTR_STATE, xml.OP_EQUALS, reflection.REVISION_PENDING, PATH_CURRENT_REVISION)
                .Attr(reflection.ATTR_STATE, xml.OP_EQUALS, reflection.REVISION_APPROVED, PATH_CURRENT_REVISION);
            return q;
        } 
    });
});